import React, { useState, useEffect, useRef, useContext } from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import GlobalData from "./GlobalData";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import RequirementsComponent from "./RequirementsComponent";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

function RequirementsContainer(props) {
  const creds = useContext(CredsContext).creds;
  const [filteredReqArray, setFilteredReqArray] = useState([]);
  const checkboxesMarked = useRef([]);
  const categoryDropdownFields = useRef({});
  const origReqArray = useRef([]);
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const selectedCategoryId = useRef();
  const projectTeam = useRef([]); // array of last, first - strings, not objects
  const approvalMembers = useRef([]);
  const acknowledgementMembers = useRef([]);
  const loadCompleted = useRef(false);
  const [openConfigAlert, setOpenConfigAlert] = useState(false);
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const REQUIREMENT_ISSUE_CATEGORY_ID = useRef();
  const REQUIREMENT_VERSION_ISSUE_CATEGORY_ID = useRef();
  const APPROVED_STAGE_ID = useRef();
  const PROPOSED_STAGE_ID = useRef();

  // determine user's full name to identify who made the change for the change log
  const userFullName = creds.name;
  const userFirstName = userFullName
    .substring(userFullName.indexOf(",") + 1)
    .trim();
  const userLastName = userFullName.substring(0, userFullName.indexOf(","));

  const oadaSettingsRaw = localStorage.getItem("oadaSettings");
  if (oadaSettingsRaw) {
    const oadaSettings = JSON.parse(oadaSettingsRaw);
    REQUIREMENT_ISSUE_CATEGORY_ID.current =
      oadaSettings["requirementCategoryDropdown_options"];
    REQUIREMENT_VERSION_ISSUE_CATEGORY_ID.current =
      oadaSettings["requirementVersionsCategoryDropdown_options"];
    APPROVED_STAGE_ID.current =
      oadaSettings["approvedRequirementStageDropdown_options"];
    PROPOSED_STAGE_ID.current =
      oadaSettings["proposedRequirementStageDropdown_options"];
  }
  useEffect(() => {
    if (
      !REQUIREMENT_ISSUE_CATEGORY_ID.current ||
      !REQUIREMENT_VERSION_ISSUE_CATEGORY_ID.current ||
      !APPROVED_STAGE_ID.current ||
      !PROPOSED_STAGE_ID.current
    ) {
      setOpenConfigAlert(true);
    }
  }, [
    REQUIREMENT_ISSUE_CATEGORY_ID.current,
    REQUIREMENT_VERSION_ISSUE_CATEGORY_ID.current,
    APPROVED_STAGE_ID.current,
    PROPOSED_STAGE_ID.current,
  ]);

  function setRequirementCategories(reqString) {
    // read requirement categories from project custom field, store in "categoryDropdownFields.current"
    const categoryDropdownString = reqString;
    let categoryValues = [];
    if (categoryDropdownString && categoryDropdownString != "undefined") {
      categoryValues = JSON.parse(categoryDropdownString);
    }
    //categoryValues.unshift({ nodeId: "00", nodeText: "All Categories" });
    categoryDropdownFields.current = {
      dataSource: categoryValues,
      value: "nodeId",
      text: "nodeText",
      child: "nodeChild",
    };

    sessionStorage.setItem("reqCategories" + projectObject.id, reqString);
  }

  useEffect(() => {
    props.waitHandler(true);

    const globalDataObject = new GlobalData(creds);
    globalDataObject.populateTable("IssueCategory").then(() => {
      const issueCategories = JSON.parse(
        localStorage.getItem(creds.company + "|IssueCategory"),
      );
      const reqCatElement = issueCategories.find(
        (elem) => elem.name == "Requirement",
      );
      const reqVersionCatElement = issueCategories.find(
        (elem) => elem.name == "Requirement Version",
      );
      if (reqCatElement && reqVersionCatElement) {
        //REQUIREMENT_ISSUE_CATEGORY_ID.current = reqCatElement.id;
        //REQUIREMENT_VERSION_ISSUE_CATEGORY_ID.current = reqVersionCatElement.id;
      } else {
        alert(
          "ERROR: Misisng Requirement and/or Requirement Version Issue Category.  If this has been resolved in SuiteProjects Pro, revisiting this page will reflect the change.  Otherwise, please contact your SuiteProjects Pro Administrator.",
        );
        localStorage.removeItem(creds.company + "|IssueCategory");
      }

      globalDataObject.populateTable("IssueStage").then(() => {
        const issueStages = JSON.parse(
          localStorage.getItem(creds.company + "|IssueStage"),
        );
        const reqApprovedElement = issueStages.find(
          (elem) => elem.name == "Approved",
        );
        const reqProposedElement = issueStages.find(
          (elem) => elem.name == "Proposed",
        );
        if (reqApprovedElement && reqProposedElement) {
          //APPROVED_STAGE_ID.current = reqApprovedElement.id;
          //PROPOSED_STAGE_ID.current = reqProposedElement.id;
        } else {
          alert(
            "ERROR: Misisng Approved and/or Proposed Issue Stage.  If this has been resolved in SuiteProjects Pro, revisiting this page will reflect the change.  Otherwise, please contact your SuiteProjects Pro Administrator.",
          );
          localStorage.removeItem(creds.company + "|IssueStage");
        }

        // read project team members from project custom field, store in "projectTeam.current"
        if (projectObject.oada_project_team__c) {
          projectTeam.current = [];
          const memberArray = projectObject.oada_project_team__c.split(";");
          memberArray.forEach((memberRecord) => {
            const firstPipe = memberRecord.indexOf("|");
            const secondPipe = memberRecord.indexOf("|", firstPipe + 1);

            projectTeam.current.push({
              name: memberRecord.substring(0, firstPipe).trim(),
              id: memberRecord.substring(firstPipe + 1, secondPipe),
            });
          });
          projectTeam.current.pop();
        }

        sessionStorage.setItem(
          "reqCheckboxes",
          JSON.stringify(checkboxesMarked.current),
        );

        // read issues from project, store in "origReqArray.current", also in state "filteredReqArray"
        const requestString =
          authString +
          '<Read type="Issue" method="equal to" limit="1000" enable_custom="1"><Issue><issue_category_id>' +
          REQUIREMENT_ISSUE_CATEGORY_ID.current +
          "</issue_category_id><project_id>" +
          projectObject.id +
          "</project_id></Issue></Read></request>";

        Tools.fetchPost(requestString, urlString, "Issue").then(
          (reqRecordXML) => {
            const reqRecords = Tools.xmlToArray(reqRecordXML.xml);
            origReqArray.current = reqRecords;

            // establish order
            origReqArray.current.forEach((elem, index) => {
              const reqNumberInName = elem.name.substring(
                elem.name.indexOf("-") + 1,
              );
              if (reqNumberInName == elem.number) {
                elem.number = index + 1;
              }
            });

            // read CHECKED requirement/user IDs from project custom field, store in "checkboxesMarked.current"
            const markedStringFromProject = projectObject.oada_req_checked__c;
            if (
              markedStringFromProject &&
              markedStringFromProject != "undefined"
            ) {
              const markedArrayFromProject = JSON.parse(
                markedStringFromProject,
              );
              let removeIndexes = [];
              markedArrayFromProject.forEach((elem, index) => {
                if (origReqArray.current.length > 0) {
                  const req = origReqArray.current.find(
                    (reqElem) => reqElem.id == elem.reqId,
                  );
                  if (req) {
                    const approvalIndex = req.oada_req_approvals__c.indexOf(
                      "[id" + elem.userId + "]",
                    );
                    const acknowledgementIndex =
                      req.oada_req_acknowledgements__c.indexOf(
                        "[id" + elem.userId + "]",
                      );
                    if (approvalIndex == -1 && acknowledgementIndex == -1) {
                      removeIndexes.push(index);
                    } else {
                      checkboxesMarked.current.push({
                        reqId: elem.reqId,
                        userId: elem.userId,
                      });
                    }
                  } else {
                    props.waitHandler(false);
                    alert(
                      "It appears there is a set of approvals/acknowledgements associated with a non-existent requirement.  Please contact your SuiteProjects Pro Administrator.",
                    );
                  }
                }
              });

              sessionStorage.setItem(
                "reqCheckboxes",
                JSON.stringify(checkboxesMarked.current),
              );

              if (removeIndexes.length > 0) {
                for (let x = 0; x < removeIndexes.length; x++) {
                  markedArrayFromProject.splice(removeIndexes[x], 1);
                }
                const updateProjectString =
                  authString +
                  '<Modify type="Project" enable_custom="1"><Project><id>' +
                  projectObject.id +
                  "</id><oada_req_checked__c>" +
                  JSON.stringify(markedArrayFromProject) +
                  "</oada_req_checked__c></Project></Modify></request>";
                Tools.fetchPost(updateProjectString, urlString);
              }
            }

            /*const localReqCategories = sessionStorage.getItem(
              "reqCategories" + projectObject.id,
            );*/

            // if (localReqCategories && localReqCategories != "[]") {
            // setRequirementCategories(localReqCategories); <-- might need only this line later
            // "loadCompleted.current" exists only to assist with waitHandler timing, no other purpose
            loadCompleted.current = true;
            setFilteredReqArray(reqRecords);
          },
        );
      });
    });
  }, []);

  // "loadCompleted.current" eists only to assist with waitHandler timing, no other purpose
  function resetLoadCompleted() {
    loadCompleted.current = false;
  }

  // Set state "filteredReqArray" when category changes
  const handleCategoryDropdownChange = (event) => {
    selectedCategoryId.current = event.itemData.id;
    let newReqArray = [];
    if (event.itemData.id == "00") {
      newReqArray = JSON.parse(JSON.stringify(origReqArray.current));
    } else {
      origReqArray.current.forEach((elem) => {
        if (elem.oada_req_category__c == event.itemData.id) {
          newReqArray.push(elem);
        }
      });
    }
    setFilteredReqArray(newReqArray);
  };

  const handleCategoryDropdownClear = () => {
    setFilteredReqArray(origReqArray.current);
  };
  // update "oada_req_checked__c" on project when checkbox is clicked.  Field will contain user/req value pair for every checked box
  // also updates sessionStorage "reqCheckboxes" with same
  const handleCheckboxClick = (event) => {
    const checked = !event.target.checked; // seems to hold the opposite value from what it actually is, so inverting it
    const userId = event.target.dataset.userid;
    const reqId = event.target.dataset.reqid;

    if (
      checked &&
      checkboxesMarked.current.indexOf({ reqId: reqId, userId: userId }) == -1
    ) {
      checkboxesMarked.current.push({ reqId: reqId, userId: userId });
    } else {
      let brakes = 0;
      while (
        checkboxesMarked.current.findIndex(
          (elem) => elem.reqId == reqId && elem.userId == userId,
        ) >= 0 &&
        brakes < 10000
      ) {
        brakes++;
        const delIndex = checkboxesMarked.current.findIndex(
          (elem) => elem.reqId == reqId && elem.userId == userId,
        );
        if (delIndex >= 0) {
          checkboxesMarked.current.splice(delIndex, 1);
        }
      }
    }
    const requirementRecord = origReqArray.current.find(
      (elem) => elem.id == reqId,
    );
    const approvalsArray = requirementRecord.oada_req_approvals__c
      ? requirementRecord.oada_req_approvals__c.split(",")
      : [];
    let approvalsExpected = 0;
    approvalsArray.forEach((elem) => {
      if (elem.length > 2) {
        approvalsExpected++;
      }
    });
    const acknowledgementsArray = requirementRecord.oada_req_acknowledgements__c
      ? requirementRecord.oada_req_acknowledgements__c.split(",")
      : [];
    let acknowledgementsExpected = 0;
    acknowledgementsArray.forEach((elem) => {
      if (elem.length > 2) {
        acknowledgementsExpected++;
      }
    });
    let sumMarked = 0;
    checkboxesMarked.current.forEach((elem) => {
      if (elem.reqId == reqId) {
        sumMarked++;
      }
    });

    const currentStage = origReqArray.current.find(
      (elem) => elem.id == reqId,
    ).issue_stage_id;
    if (sumMarked == approvalsExpected + acknowledgementsExpected) {
      if (currentStage != APPROVED_STAGE_ID.current) {
        const updateReqString =
          authString +
          '<Modify type="Issue" enable_custom="1"><Issue><id>' +
          reqId +
          "</id><issue_stage_id>" +
          APPROVED_STAGE_ID.current +
          "</issue_stage_id><oada_req_previous_approved_details__c>" +
          Tools.encodeHTML(requirementRecord.oada_req_details__c) +
          "</oada_req_previous_approved_details__c></Issue></Modify></request>";

        Tools.fetchPost(updateReqString, urlString);
        origReqArray.current.find((elem) => elem.id == reqId).issue_stage_id =
          APPROVED_STAGE_ID.current;
      }
    } else {
      if (currentStage != PROPOSED_STAGE_ID.current) {
        const updateReqString =
          authString +
          '<Modify type="Issue"><Issue><id>' +
          reqId +
          "</id><issue_stage_id>" +
          PROPOSED_STAGE_ID.current +
          "</issue_stage_id></Issue></Modify></request>";

        Tools.fetchPost(updateReqString, urlString);
        origReqArray.current.find((elem) => elem.id == reqId).issue_stage_id =
          PROPOSED_STAGE_ID.current;
      }
    }
    sessionStorage.setItem(
      "reqCheckboxes",
      JSON.stringify(checkboxesMarked.current),
    );

    const updateString =
      authString +
      '<Modify type="Project" enable_custom="1"><Project><id>' +
      projectObject.id +
      "</id><oada_req_checked__c>" +
      JSON.stringify(checkboxesMarked.current) +
      "</oada_req_checked__c></Project></Modify></request>";

    Tools.fetchPost(updateString, urlString);
    projectObject.oada_req_checked__c = JSON.stringify(
      checkboxesMarked.current,
    );

    const newReqArray = [];
    origReqArray.current.forEach((elem) => {
      if (selectedCategoryId.current && selectedCategoryId.current != "00") {
        if (elem.oada_req_category__c == selectedCategoryId.current) {
          newReqArray.push(elem);
        }
      } else {
        newReqArray.push(elem);
      }
    });

    setFilteredReqArray(newReqArray);
  };

  // deletes a requirement from OA, also removes from origReqArray.current and filteredReqArray state
  const handleDeleteRequirement = (reqId) => {
    const deleteReqString =
      authString +
      '<Delete type="Issue"><Issue><id>' +
      reqId +
      "</id></Issue></Delete></request>";
    Tools.fetchPost(deleteReqString, urlString);

    // remove from displayed req list
    const delIndex = origReqArray.current.findIndex((elem) => elem.id == reqId);
    console.log(delIndex);
    origReqArray.current.splice(delIndex, 1);
    const newReqArray = [];
    const categoryArray = [];
    origReqArray.current.forEach((elem) => {
      /*if (selectedCategoryId.current && selectedCategoryId.current != "00") {
        if (elem.oada_req_category__c == selectedCategoryId.current) {
          newReqArray.push(elem);
        }
      } else {
        newReqArray.push(elem);
      }*/
      newReqArray.push(elem);
      if (categoryArray.indexOf(elem.oada_req_category_name__c) == -1) {
        categoryArray.push(elem.oada_req_category_name__c);
      }
      projectObject.oada_req_categories__c = categoryArray.join("||");
      sessionStorage.setItem("projectObject", JSON.stringify(projectObject));
    });

    // reset req categories on project record
    const projUpdateRequest =
      authString +
      '<Modify type="Project" enable_custom="1"><Project><id>' +
      projectObject.id +
      "</id><oada_req_categories__c>" +
      categoryArray.join("||") +
      "</oada_req_categories__c></Project></Modify></request>";
    Tools.fetchPost(projUpdateRequest, urlString);

    // refresh screen
    setFilteredReqArray(newReqArray);
  };

  // updates a requirement in OA, adds a new revision, reset filteredReqArray state
  const updateRequirement = (
    req,
    approvalString,
    acknowledgementString,
    editorDetails,
  ) => {
    const changeArray = [];
    let clearApprovals = false;
    let clearAcknowledgements = false;
    const cloneOrigReqArray = JSON.parse(JSON.stringify(origReqArray.current));
    const foundOrigIndex = cloneOrigReqArray.findIndex(
      (elem) => elem.id == req.id,
    );
    if (req.categoryName === null) {
      req.cateogryName = "";
    }

    req.synopsis = req.synopsis.replace("&", "&amp;");
    let nextVersionNumber;

    let changeMessage =
      origReqArray.current[foundOrigIndex].oada_issue_change_log__c || "";

    const previousDetails =
      cloneOrigReqArray[foundOrigIndex].oada_req_details__c;

    // compare each field to previous value, add to change message as needed
    if (origReqArray.current[foundOrigIndex].description != req.synopsis) {
      changeArray.push({
        field: "Description",
        oldVal: origReqArray.current[foundOrigIndex].description,
        newVal: req.synopsis,
      });
      origReqArray.current[foundOrigIndex].description = req.synopsis;
    }
    if (origReqArray.current[foundOrigIndex].issue_stage_id != req.stageId) {
      changeArray.push({
        field: "Stage ID",
        oldVal: origReqArray.current[foundOrigIndex].issue_stage_id,
        newVal: req.stageId,
      });
      origReqArray.current[foundOrigIndex].issue_stage_id = req.stageId;
    }
    if (
      origReqArray.current[foundOrigIndex].oada_req_category_name__c !=
      req.categoryName
    ) {
      changeArray.push({
        field: "Category",
        oldVal: origReqArray.current[foundOrigIndex].oada_req_category_name__c,
        newVal: req.categoryName,
      });
      origReqArray.current[foundOrigIndex].oada_req_category__c =
        req.categoryId;
      origReqArray.current[foundOrigIndex].oada_req_category_name__c =
        req.categoryName;
    }
    if (
      origReqArray.current[foundOrigIndex].oada_req_details__c != editorDetails
    ) {
      changeArray.push({
        field: "Details",
        oldVal: origReqArray.current[foundOrigIndex].oada_req_details__c,
        newVal: editorDetails,
      });
      origReqArray.current[foundOrigIndex].oada_req_previous_details__c =
        origReqArray.current[foundOrigIndex].oada_req_details__c;
      origReqArray.current[foundOrigIndex].oada_req_details__c = editorDetails;

      //also changed stage to Proposed from Approved
      if (
        origReqArray.current[foundOrigIndex].issue_stage_id ==
        APPROVED_STAGE_ID.current
      ) {
        changeArray.push({
          field: "Stage ID",
          oldVal: APPROVED_STAGE_ID.current,
          newVal: PROPOSED_STAGE_ID.current,
        });
        origReqArray.current[foundOrigIndex].issue_stage_id =
          PROPOSED_STAGE_ID.current;
      }
    }
    if (
      origReqArray.current[foundOrigIndex].oada_req_approvals__c !=
      approvalString
    ) {
      changeArray.push({
        field: "Approvals",
        oldVal: origReqArray.current[foundOrigIndex].oada_req_approvals__c,
        newVal: approvalString,
      });
      if (approvalString == "") {
        clearApprovals = true;
      }
      origReqArray.current[foundOrigIndex].oada_req_approvals__c =
        approvalString;
    }
    if (
      origReqArray.current[foundOrigIndex].oada_req_acknowledgements__c !=
      acknowledgementString
    ) {
      changeArray.push({
        field: "Acknowledgements",
        oldVal:
          origReqArray.current[foundOrigIndex].oada_req_acknowledgements__c,
        newVal: acknowledgementString,
      });
      if (acknowledgementString == "") {
        clearAcknowledgements = true;
      }
      origReqArray.current[foundOrigIndex].oada_req_acknowledgements__c =
        acknowledgementString;
    }
    /*
    cloneOrigReqArray[foundOrigIndex].description = req.synopsis;
    cloneOrigReqArray[foundOrigIndex].issue_stage_id = req.stageId;
    cloneOrigReqArray[foundOrigIndex].oada_req_category__c = req.categoryId;
    cloneOrigReqArray[foundOrigIndex].oada_req_previous_details__c =
      cloneOrigReqArray[foundOrigIndex].oada_req_details__c;
    cloneOrigReqArray[foundOrigIndex].oada_req_details__c = editorDetails;
    cloneOrigReqArray[foundOrigIndex].oada_req_approvals__c = approvalString;
    cloneOrigReqArray[foundOrigIndex].oada_req_acknowledgements__c =
      acknowledgementString;

    origReqArray.current = cloneOrigReqArray;*/

    let detailsChanged = false;
    if (Tools.encodeHTML(editorDetails) != Tools.encodeHTML(previousDetails)) {
      detailsChanged = true;
    }

    if (changeArray.length > 0) {
      if (detailsChanged) {
        // determine next version number
        nextVersionNumber =
          cloneOrigReqArray[foundOrigIndex].oada_req_version__c == ""
            ? 1
            : parseInt(
                cloneOrigReqArray[foundOrigIndex].oada_req_version__c.substring(
                  1,
                ),
              );

        // create new requrirement revision in OA
        const storeOrigReqString =
          authString +
          '<Add type="Issue" enable_custom="1"><Issue><date>' +
          Tools.parseDateObject(new Date()) +
          "</date><project_id>" +
          cloneOrigReqArray[foundOrigIndex].project_id +
          "</project_id><customer_id>" +
          cloneOrigReqArray[foundOrigIndex].customer_id +
          "</customer_id><owner_id>" +
          cloneOrigReqArray[foundOrigIndex].owner_id +
          "</owner_id><description>Version " +
          nextVersionNumber +
          " of " +
          cloneOrigReqArray[foundOrigIndex].description +
          "</description><issue_stage_id>" +
          cloneOrigReqArray[foundOrigIndex].issue_stage_id +
          "</issue_stage_id><oada_req_category__c>" +
          cloneOrigReqArray[foundOrigIndex].oada_req_category__c +
          "</oada_req_category__c><oada_req_details__c>" +
          Tools.encodeHTML(
            cloneOrigReqArray[foundOrigIndex].oada_req_details__c,
          ) +
          "</oada_req_details__c><oada_req_version__c>" +
          nextVersionNumber +
          "</oada_req_version__c><oada_req_approvals__c>" +
          cloneOrigReqArray[foundOrigIndex].oada_req_approvals__c +
          "</oada_req_approvals__c><oada_req_acknowledgements__c>" +
          cloneOrigReqArray[foundOrigIndex].oada_req_acknowledgements__c +
          "</oada_req_acknowledgements__c><issue_category_id>" +
          REQUIREMENT_VERSION_ISSUE_CATEGORY_ID.current +
          "</issue_category_id></Issue></Add></request>";

        Tools.fetchPost(storeOrigReqString, urlString);
      }

      // build change message for requirement change
      changeArray.forEach((changeElem) => {
        changeMessage +=
          new Date().getTime() +
          "|" +
          userFirstName +
          " " +
          userLastName +
          ":c:" + // changed
          changeElem.field +
          ":f:";

        if (changeElem.field != "Details") {
          if (
            changeElem.field == "Approvals" ||
            changeElem.field == "Acknowledgements"
          ) {
            //remove [id##] from values
            if (changeElem.oldVal.indexOf("[id") >= 0) {
              changeElem.oldVal = changeElem.oldVal.replace(/\[id\d*\]/g, "");
            }
            if (changeElem.newVal.indexOf("[id") >= 0) {
              changeElem.newVal = changeElem.newVal.replace(/\[id\d*\]/g, "");
            }
          }
          changeMessage += changeElem.oldVal + ":t:" + changeElem.newVal; // from, to
        }

        changeMessage +=
          ":o:" + // on
          new Date().toDateString() +
          " at " +
          new Date().toLocaleTimeString("en-US", {
            timeZone: "America/New_York",
          }) +
          " ET||";
      });

      // modify requirement record in OA
      const modifiedStageId = detailsChanged
        ? PROPOSED_STAGE_ID.current
        : req.stageId;
      const updateReqString =
        authString +
        '<Modify type="Issue" enable_custom="1"><Issue><id>' +
        req.id +
        "</id><issue_stage_id>" +
        modifiedStageId +
        "</issue_stage_id><oada_req_category__c>" +
        req.categoryId +
        "</oada_req_category__c><oada_req_category_name__c>" +
        req.categoryName +
        "</oada_req_category_name__c><description>" +
        req.synopsis +
        "</description><oada_req_details__c>" +
        Tools.encodeHTML(editorDetails) +
        "</oada_req_details__c><oada_req_previous_details__c>" +
        Tools.encodeHTML(previousDetails) +
        "</oada_req_previous_details__c><oada_req_version__c>-" +
        (nextVersionNumber + 1) +
        "</oada_req_version__c><oada_req_approvals__c>" +
        approvalString +
        "</oada_req_approvals__c><oada_req_acknowledgements__c>" +
        acknowledgementString +
        "</oada_req_acknowledgements__c><oada_issue_change_log__c>" +
        changeMessage +
        "</oada_issue_change_log__c></Issue></Modify></request>";

      Tools.fetchPost(updateReqString, urlString);

      if (clearApprovals) {
        const clearApprovalsString =
          authString +
          '<Modify type="Issue" method="custom equal to"><Issue><id>' +
          req.id +
          "</id><custom_field>oada_req_approvals</custom_field><value></value></Issue></Modify></request>";
        Tools.fetchPost(clearApprovalsString, urlString);
      }
      if (clearAcknowledgements) {
        const clearAcknowledgementsString =
          authString +
          '<Modify type="Issue" method="custom equal to"><Issue><id>' +
          req.id +
          "</id><custom_field>oada_req_acknowledgements</custom_field><value></value></Issue></Modify></request>";
        Tools.fetchPost(clearAcknowledgementsString, urlString);
      }
    }
    // clear approval checkboxes if details have changed
    if (detailsChanged) {
      const newChecked = [];
      if (projectObject.oada_req_checked__c != "") {
        const checked = JSON.parse(projectObject.oada_req_checked__c);
        checked.forEach((elem) => {
          if (elem.reqId != req.id) {
            newChecked.push(elem);
          }
        });

        const projUpdateString =
          authString +
          '<Modify type="Project" enable_custom="1"><Project><id>' +
          projectObject.id +
          "</id><oada_req_checked__c>" +
          JSON.stringify(newChecked) +
          "</oada_req_checked__c></Project></Modify></request>";

        projectObject.oada_req_checked__c = JSON.stringify(newChecked);
        sessionStorage.removeItem("reqCheckboxes");
        sessionStorage.setItem("reqCheckboxes", JSON.stringify(newChecked));
        checkboxesMarked.current = newChecked;

        Tools.fetchPost(projUpdateString, urlString);
      }
    }
    const newReqArray = [];
    origReqArray.current.forEach((elem) => {
      if (selectedCategoryId.current && selectedCategoryId.current != "00") {
        if (elem.oada_req_category__c == selectedCategoryId.current) {
          newReqArray.push(elem);
        }
      } else {
        newReqArray.push(elem);
      }
    });

    if (
      projectObject.oada_req_categories__c.indexOf(req.categoryName) == -1 &&
      req.categoryName != ""
    ) {
      projectObject.oada_req_categories__c += "||" + req.categoryName;
      sessionStorage.setItem("projectObject", JSON.stringify(projectObject));
      const updateProjectString =
        authString +
        '<Modify type="Project" enable_custom="1"><Project><id>' +
        projectObject.id +
        "</id><oada_req_categories__c>" +
        projectObject.oada_req_categories__c +
        "</oada_req_categories__c></Project></Modify></request>";
      Tools.fetchPost(updateProjectString, urlString);
    }

    setFilteredReqArray(newReqArray);
  };

  // adds a new requirement to OA, also updates filteredReqArray state
  const addRequirement = (
    passedReq,
    approvalString,
    acknowledgementString,
    editorDetails,
  ) => {
    const req = JSON.parse(JSON.stringify(passedReq));
    //const users = JSON.parse(localStorage.getItem(creds.company + "|User"));
    if (req.categoryName === null) {
      req.cateogryName = "";
    }
    let changeMessage =
      new Date().getTime() +
      "|" +
      userFirstName +
      " " +
      userLastName +
      ":c:CREATED:f::t::o:" + // on
      new Date().toDateString() +
      " at " +
      new Date().toLocaleTimeString("en-US", {
        timeZone: "America/New_York",
      }) +
      " ET||";

    const addReqString =
      authString +
      '<Add type="Issue" enable_custom="1"><Issue><date>' +
      Tools.parseDateObject(new Date()) +
      "</date><issue_stage_id>" +
      req.stageId +
      "</issue_stage_id><issue_category_id>" +
      REQUIREMENT_ISSUE_CATEGORY_ID.current +
      "</issue_category_id><oada_req_category__c>" +
      req.categoryId +
      "</oada_req_category__c><oada_req_category_name__c>" +
      req.categoryName +
      "</oada_req_category_name__c><oada_req_approvals__c>" +
      approvalString +
      "</oada_req_approvals__c><oada_req_acknowledgements__c>" +
      acknowledgementString +
      "</oada_req_acknowledgements__c><description>" +
      req.synopsis +
      "</description><oada_req_details__c>" +
      Tools.encodeHTML(editorDetails) +
      "</oada_req_details__c><owner_id>" +
      creds.id +
      "</owner_id><project_id>" +
      projectObject.id +
      "</project_id><oada_issue_change_log__c>" +
      changeMessage +
      "</oada_issue_change_log__c></Issue></Add></request>";

    Tools.fetchPost(addReqString, urlString, "Issue").then(
      (issueRecResponse) => {
        const issueRec = Tools.xmlToArray(issueRecResponse.xml);
        let createdReq = {
          id: issueRec[0].id,
          name: issueRec[0].name,
          description: req.synopsis,
          issue_stage_id: req.stageId,
          oada_req_category__c: req.categoryId,
          oada_req_category_name__c: req.categoryName,
          oada_req_details__c: editorDetails,
          oada_req_approvals__c: approvalString,
          oada_req_acknowledgements__c: acknowledgementString,
          oada_req_version__c: "",
        };

        origReqArray.current.push(createdReq);

        const newReqArray = [];
        origReqArray.current.forEach((elem) => {
          if (
            selectedCategoryId.current &&
            selectedCategoryId.current != "00"
          ) {
            if (elem.oada_req_category__c == selectedCategoryId.current) {
              newReqArray.push(elem);
            }
          } else {
            newReqArray.push(elem);
          }
        });

        setFilteredReqArray(newReqArray);
      },
    );

    const projRequirementCategories =
      projectObject.oada_req_categories__c.split("||");
    if (
      projRequirementCategories.indexOf(req.categoryName) == -1 &&
      req.categoryName != ""
    ) {
      addProjectRequirementCategory(req.categoryName);
    }
  };

  function addProjectRequirementCategory(newCat) {
    const projRequirementCategories =
      projectObject.oada_req_categories__c.split("||");
    projRequirementCategories.push(newCat);
    projRequirementCategories.sort();
    const projRequirementCategoriesString =
      projRequirementCategories.join("||");
    const requestString =
      authString +
      '<Modify type="Project" enable_custom="1"><Project><id>' +
      projectObject.id +
      "</id><oada_req_categories__c>" +
      projRequirementCategoriesString +
      "</oada_req_categories__c></Project></Modify></request>";
    projectObject.oada_req_categories__c = projRequirementCategoriesString;
    sessionStorage.setItem("projectObject", JSON.stringify(projectObject));
    Tools.fetchPost(requestString, urlString);
  }

  const handleNotificationClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpenConfigAlert(false);
  };

  // Template for "Approvals" and "Acknowledgements" columns (checkbox components)
  function reqPersonnelTemplateProcessing(
    personnelField,
    reqId,
    checkboxClass,
  ) {
    let returnValue;
    if (personnelField) {
      // parse comma-delimited string
      /*const personnelArray = personnelField.match(
        /(".*?"|[^",\s]+)(?=\s*,|\s*$)/g,
      );*/
      const personnelArray = personnelField.match(
        /(".*?"|[^",]+)(?=\s*,|\s*$)/g,
      );

      returnValue = [];
      const currentCheckboxStatesString =
        sessionStorage.getItem("reqCheckboxes");
      let currentCheckboxStates;
      if (
        currentCheckboxStatesString &&
        currentCheckboxStatesString != "undefined"
      ) {
        currentCheckboxStates = JSON.parse(currentCheckboxStatesString);
      }

      personnelArray.forEach((elem, index) => {
        const elemString = JSON.stringify(elem);
        const trimmedValue1 = elemString
          .substring(1, elemString.indexOf("["))
          .trim();
        //const trimmedValue =
        //  trimmedValue1.substring(trimmedValue1.indexOf("_") + 1) +
        //  " " +
        //  trimmedValue1.substring(0, trimmedValue1.indexOf("_"));
        const trimmedValue = trimmedValue1;

        const userId = elemString.substring(
          elemString.indexOf("[") + 3,
          elemString.indexOf("]"),
        );

        let isChecked = false;
        if (currentCheckboxStates) {
          isChecked =
            currentCheckboxStates.findIndex(
              (elem) => elem.reqId == reqId && elem.userId == userId,
            ) >= 0;
        }
        // prevent checkbox for ""
        if (trimmedValue.length > 2) {
          returnValue.push(
            <div key={index}>
              <CheckBoxComponent
                cssClass={checkboxClass}
                onClick={handleCheckboxClick}
                checked={isChecked}
                label={trimmedValue}
                data-userid={userId}
                data-reqid={reqId}
                disabled={userId != creds.id && creds.projectRole != "F"}
              />
              <br></br>
            </div>,
          );
        }
      });
    } else {
      returnValue = null;
    }
    return returnValue;
  }

  const redirectToSettings = () => {
    setOpenConfigAlert(false);
    props.openSettings();
  };

  async function executeCopy(from, to) {
    props.waitHandler(true);
    const fromId = from.substring(from.indexOf("_") + 1);
    const requestString =
      authString +
      '<Read type="Issue" method="equal to" limit="1000" enable_custom="1"><Issue><id>' +
      fromId +
      "</id></Issue></Read></request>";

    const reqRecordXML = await Tools.fetchPost(
      requestString,
      urlString,
      "Issue",
    );
    const reqRecords = Tools.xmlToArray(reqRecordXML.xml);
    const approvers = reqRecords[0].oada_req_approvals__c;
    const acknowledgers = reqRecords[0].oada_req_acknowledgements__c;
    let modifyString = authString;
    const newReqArray = [...filteredReqArray];
    for (let i = 0; i < to.length; i++) {
      const toId = to[i].substring(to[i].indexOf("_") + 1);
      const reqRecordIndex = filteredReqArray.findIndex(
        (elem) => elem.id == toId,
      );

      newReqArray[reqRecordIndex].oada_req_approvals__c = approvers;
      newReqArray[reqRecordIndex].oada_req_acknowledgements__c = acknowledgers;

      modifyString +=
        '<Modify type="Issue" enable_custom="1"><Issue><id>' +
        toId +
        "</id><oada_req_approvals__c>" +
        approvers +
        "</oada_req_approvals__c><oada_req_acknowledgements__c>" +
        acknowledgers +
        "</oada_req_acknowledgements__c></Issue></Modify>";
    }
    modifyString += "</request>";

    const modifyResults = await Tools.fetchPost(modifyString, urlString);
    setFilteredReqArray(newReqArray);
    props.waitHandler(false);
    return true;
  }

  return (
    <>
      <RequirementsComponent
        reqArray={filteredReqArray}
        projectObject={projectObject}
        waitHandler={props.waitHandler}
        handleCheckboxClick={handleCheckboxClick}
        categoryDropdownFields={categoryDropdownFields.current}
        handleCategoryDropdownChange={handleCategoryDropdownChange}
        handleCategoryDropdownClear={handleCategoryDropdownClear}
        updateRequirement={updateRequirement}
        addRequirement={addRequirement}
        projectTeam={projectTeam.current}
        approvalMembers={approvalMembers.current}
        acknowledgementMembers={acknowledgementMembers.current}
        reqPersonnelTemplateProcessing={reqPersonnelTemplateProcessing}
        loadCompleted={loadCompleted.current}
        resetLoadCompleted={resetLoadCompleted}
        deleteRequirement={handleDeleteRequirement}
        executeCopy={executeCopy}
      />
      <Dialog open={openConfigAlert} onClose={handleNotificationClose}>
        <Alert
          variant="filled"
          onClose={handleNotificationClose}
          severity="error"
          sx={{ fontSize: "large" }}
        >
          Configuration of Categories and Stages is not complete. An
          administrator must identify these in the SPP Instance Settings in
          order for this module to function properly.
          <DialogActions sx={{ paddingRight: "30px" }}>
            <Button
              className="settingsButtonActive"
              variant="filled"
              value="OK"
              onClick={redirectToSettings}
              sx={{ margin: "0px !important" }}
            >
              OK
            </Button>
          </DialogActions>
        </Alert>
      </Dialog>
    </>
  );
}
export default RequirementsContainer;

RequirementsContainer.propTypes = {
  waitHandler: PropTypes.func,
  openSettings: PropTypes.func,
};
